export const $platformCode = '0005'